import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-petrol" data-id="element-62" data-mp="c6iqpiikbh1v">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-63" data-mp="c4oa2gebqb3l">
        <p className="inline-block rounded-md bg-brand-emerald px-2 py-0.5 font-sub text-xs font-semibold uppercase tracking-widest text-white" data-id="element-64" data-mp="83m5rl5jv8ur">
          Tu próximo paso
        </p>
        <h2 id="cierre" className="mt-2 font-display text-[2rem] leading-none text-white sm:text-5xl" data-id="element-65" data-mp="h4u586jsyfqf">
          Podés comenzar a ordenar los temas que hoy tenés repartidos entre{' '}
          <span className="text-brand-mint" data-id="element-66" data-mp="qw6vitpycxuc">apuntes, archivos y capturas.</span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-ivory" data-id="element-67" data-mp="14w7vm6ye818r">
          Construí una base, conectá conceptos y practicá con un recorrido
          organizado para acompañar tu cursada.
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-brand-gold bg-white p-3 text-brand-petrol" data-id="element-68" data-mp="2c6hgc7ianjc3">
          <p className="font-sub text-sm font-bold uppercase leading-tight text-brand-emerald" data-id="element-69" data-mp="2h5kmxwdx9xm6">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-3xl leading-none" data-id="element-70" data-mp="2r277ek2c6mno">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 font-display text-6xl leading-none text-brand-emerald sm:text-7xl" data-id="element-71" data-mp="2v2hey15s1l4n">
            {PRICE}{' '}
            <span className="text-3xl text-brand-petrol sm:text-4xl" data-id="element-72" data-mp="3010wzqh92crq">ARS</span>
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-73" data-mp="34tu6ernny9a5">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-brand-muted" data-id="element-74" data-mp="39u9g998qkynd">
            Material digital • Pago único • Estudiá a tu ritmo
          </p>
        </Reveal>
      </div>
    </section>;
}